"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtractRefreshComponent = exports.extractRefreshTestId = void 0;
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var Id_1 = require("../common/Id");
exports.extractRefreshTestId = 'extract-refresh-information';
var lastExtractKey = 'last-extract';
var dateKey = 'date';
function ExtractRefreshComponent(_a) {
    var date = _a.date, id = _a.id, customStyle = _a.customStyle;
    var content;
    if (date) {
        content = [
            React.createElement("span", { key: lastExtractKey, style: customStyle }, Localize_1.Messages.CertifiedDatasource()),
            React.createElement("span", { key: dateKey, style: customStyle }, '(' + Localize_1.Formatters.formatMediumDateTimeWithoutMinutes(date) + ')')
        ];
    }
    else {
        content = Localize_1.Messages.CertifiedDatasourceLive();
    }
    return (React.createElement("div", { "data-tb-test-id": (0, Id_1.generateId)(exports.extractRefreshTestId, id), style: customStyle }, content));
}
exports.ExtractRefreshComponent = ExtractRefreshComponent;
//# sourceMappingURL=ExtractRefresh.js.map